/*
 * @Description: 微信平台数字品牌价值及三维度
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 11:27:36
 * @LastEditTime: 2019-09-24 15:30:58
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p12.css';

import { getSessionQuery } from '../../../utils';
import ExportNav from '../../../components/ExportNav/ExportNav';
import Platform from './platform';

const platformList = [
  {
    key: 'wx',
    name: '微信',
  },
  {
    key: 'wb',
    name: '微博',
  },
  {
    key: 'zh',
    name: '知乎',
  },
  {
    key: 'tt',
    name: '今日头条',
  },
  {
    key: 'wk',
    name: '悟空问答'
  }
];

class P12 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      component: ''
    }

    this.getData = this.getData.bind(this);
    this.toggleComponent = this.toggleComponent.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result

  }

  getData () {
    const query = this.getQuery();

    this.setState({
      query: query
    }, () => {
      this.toggleComponent(platformList[0])
    });
  }

  
  toggleComponent (item) {
    const query = Object.assign({}, this.state.query, {
      platform: item.key,
      report: true
    });

    this.setState({
      component: ''
    }, () => {
      this.setState({
        component: <Platform query={query} name={item.name}></Platform>
      });
    });
  }

  render() {
    const {component} = this.state;
    return (
      <div className={s.container}>
        <ExportNav
          list={platformList}
          clickHandle={this.toggleComponent}>
        </ExportNav>
        {component}
      </div>
    );
  }
}

export default withStyles(s)(P12);



// WEBPACK FOOTER //
// src/routes/exportPDF/p12/p12.js